// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3Jz62","rootSmall":"AddTileButton_rootSmall__2kbxy"};